import { receiptVisitId } from "@/UI/pages/visitsNew/Lib/money";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export class VisitSupportMix extends Vue {
    get visitRouteId(): string {
        const params = this.$router.currentRoute.params;
        return params.form ? String(receiptVisitId(params)) : params.id;
    }
    async paymentLink(): Promise<void> {
        await Vue.router.push({
            name: this.$routeRules.VisitsNewPay,
            params: { id: this.visitRouteId },
        });
    }
    async statusLink(): Promise<void> {
        await Vue.router.push({
            name: this.$routeRules.VisitsNewStatus,
            params: { id: this.visitRouteId },
        });
    }
    async historyLink(): Promise<void> {
        await Vue.router.push({
            name: this.$routeRules.VisitsNewHistory,
            params: { id: this.visitRouteId },
        });
    }
    async productsLink():Promise<void> {
        await Vue.router.push({
            name: this.$routeRules.VisitsNewProducts,
            params: { id: this.visitRouteId },
        });
    }

    async detailLink(): Promise<void> {
        await Vue.router.push({
            name: this.$routeRules.VisitsNewDetail,
            params: { id: this.visitRouteId },
        });
    }
}
